<template>
	<Transition name="slide-fade" mode="out-in">
		<router-view />
	</Transition>
	<ToastContainer />

	<!-- Custom Global PWA Install Banner -->
	<div v-if="isInstallable && !dismissedInstall"
		class="fixed bottom-4 left-4 right-4 sm:left-1/2 sm:right-auto sm:-translate-x-1/2 sm:w-[380px] z-[9999] bg-white dark:bg-gray-900 rounded-xl shadow-[0_8px_30px_rgb(0,0,0,0.12)] border border-gray-100 dark:border-gray-800 p-2 pl-3 flex items-center justify-between transition-all duration-300">
		<div class="flex items-center gap-3">
			<div class="w-8 h-8 relative flex items-center justify-center flex-shrink-0">
				<img :src="`${publicPath}icons/favicon-96x96.png`" alt="App Icon"
				class="w-full h-full object-contain drop-shadow-sm" />
			</div>
			<span class="font-semibold text-[15px] text-gray-900 dark:text-gray-100">Install App</span>
		</div>

		<div class="flex items-center gap-2 pr-1">
			<button @click="promptInstall"
				class="px-5 py-1.5 bg-[#4F46E5] text-white text-[14px] font-medium rounded-md hover:bg-[#4338CA] transition-colors shadow-sm tracking-wide">
				Install
			</button>
			<button @click="dismissInstall"
				class="p-1 px-1.5 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
				aria-label="Close">
				<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
				<path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6 18L18 6M6 6l12 12"></path>
				</svg>
			</button>
		</div>
	</div>
</template>

<script setup lang="ts">
import { useTitle } from '@/composables/ui/useTitle'
import { useColorScheme } from '@/composables/ui/useColorScheme'
import { computed, onMounted, ref } from 'vue'
import { useThemeStore } from '@/stores/theme'
import ToastContainer from '@/components/layout/ToastContainer.vue'
import { usePWAInstall } from '@/composables/ui/usePWAInstall'

const { isInstallable, promptInstall } = usePWAInstall()
const dismissedInstall = ref(false)
const publicPath = process.env.BASE_URL || '/'

const dismissInstall = () => {
  dismissedInstall.value = true
}

const appTitle = computed(() => process.env.VUE_APP_TITLE || 'PLANET Home Healthcare')
useTitle(appTitle.value)

useColorScheme()

const themeStore = useThemeStore()

onMounted(() => {
  	themeStore.initializeTheme()
})
</script>

<style>
/* Global styles */
html {
  	font-family: 'Syne, sans-serif', sans-serif;
}

body {
	font-family: 'Syne, sans-serif', sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}

/* Dark mode styles */
.dark {
  	color-scheme: dark;
}

/* Color scheme transitions */
* {
	transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
	transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
	transition-duration: 150ms;
}

/* Smooth Transition */
.slide-fade-enter-active, .slide-fade-leave-active {
	transition: all 0.3s ease;
}
.slide-fade-enter-from {
	opacity: 0;
	transform: translateY(10px);
}
.slide-fade-leave-to {
	opacity: 0;
	transform: translateY(-10px);
}
</style>
